import { render, staticRenderFns } from "./ServicosOrdemServico.vue?vue&type=template&id=f5cad808&scoped=true&"
import script from "./ServicosOrdemServico.vue?vue&type=script&lang=js&"
export * from "./ServicosOrdemServico.vue?vue&type=script&lang=js&"
import style0 from "./ServicosOrdemServico.vue?vue&type=style&index=0&id=f5cad808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cad808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
